// extracted by mini-css-extract-plugin
export default {"spinner":"src-modules-icons-SpinnerIcon-style__spinner_ZmMe1","spin":"src-modules-icons-SpinnerIcon-style__spin_wLjQi"};